import {
  Button,
  Container,
  Nav,
  Navbar,
} from "react-bootstrap";
import * as Scroll from "react-scroll";

import Image from "../../components/CustomImage";
import constants from "../../lib/constants";

const SubMenu = (props) => {
  const { company, contact = {}, show, reviews = [] } = props;

  const companyLink = company.company_website_url || contact.contact_website || '#';

  const logoUrl = company.company_logo_url && company.company_logo_url.length > 0
    ? `${constants.LOGO_URL}/${company.company_logo_url[0].name}`
    : null;

  return (
    <Navbar
      className="shadow sub-menu px-4"
      bg="white"
      sticky="top"
      variant="pills"
      style={{ display: show ? 'flex' : 'none' }}
    >
      <Container className="justify-content-start">
        <Navbar.Brand
          className="py-0 avatar avatar-md avatar-border-white flex-shrink-0 overflow-hidden"
        >
          <Image
            src={logoUrl}
            width="45"
            height="45"
            alt={`${company.company_name} logo`}
            className="d-block"
            fallback={company.company_name ? company.company_name.charAt(0) : ''}
          />
        </Navbar.Brand>
        <div className="w-100 d-flex overflow-auto hide-scrollbar">
          <Nav className="me-auto gap-2">
            <Scroll.Link
              to="about"
              offset={-100}
              spy={true}
              activeClass="active"
              className="nav-link text-sm"
              role="button"
            >
              About
            </Scroll.Link>
            <Scroll.Link
              to="speciality"
              offset={-100}
              spy={true}
              activeClass="active"
              className="nav-link text-sm"
              role="button"
            >
              Speciality
            </Scroll.Link>
            <Scroll.Link
              to="feedback"
              offset={-100}
              spy={true}
              activeClass="active"
              className="nav-link text-sm"
              role="button"
            >
              Top mentions
            </Scroll.Link>
            {reviews && reviews.length > 0 && (
              <Scroll.Link
                to="reviews"
                offset={-100}
                spy={true}
                activeClass="active"
                className="nav-link text-sm"
                role="button"
              >
                Reviews
              </Scroll.Link>
            )}
            <Scroll.Link
              to="location"
              offset={-100}
              spy={true}
              activeClass="active"
              className="nav-link text-sm"
              role="button"
            >
              Location
            </Scroll.Link>
          </Nav>
          {/* Desktop button */}
          <Nav.Link
            href={companyLink}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className='pe-0 d-none d-sm-inline-block'
          >
            <Button variant="secondary">Visit website</Button>
          </Nav.Link>
          {/* Mobile button */}
          <div className="d-block d-sm-none fixed-bottom p-2 bg-white border-top text-center">
            <Button
              href={companyLink}
              target="_blank"
              rel="nofollow noopener noreferrer"
              variant="primary"
              className="w-100"
            >
              Visit website
            </Button>
          </div>
        </div>
      </Container>
    </Navbar>);
}

export default SubMenu;
